import MainPage from 'pages/MainPage';
import React from 'react';

const App = () => {
  return (
    <div>
      <MainPage />
    </div>
  );
};

export default App;
